import './App.css';
import Search from './components/search/Search';
import CurrentWeather from './components/current-weather/current-weather';
import { WEATHER_API_URL, WEATHER_API_KEY } from "./api"
import { useState } from 'react';
import Forecast from './components/forecast/forecast';
import Header from './components/Header';
import Footer from './components/Footer';

function App() {
  const [currentWeather, setCurrentWeather] = useState(null);
  const [forecastWeather, setForecastWeather] = useState(null);

  //3
  //WE ARE TRYING TO OBTAIN TWO TYPES OF DATA -> ONE FOR CURRENT WEATHER AND OTHER FOR FORECAST OF THE WEATHER
  // {value: '25.3575 55.391944444', label: 'Sharjah AE'}
  // label: "Sharjah AE"
  // value: "25.3575 55.391944444"
  // We have above form of data coming
  const handleOnSearchChange = (searchData) => { //Handle the function named as handleOnSearchChange 
    const [lat, lon] = searchData.value.split(" ");//splitting the long and latitude data  
    //Its for current weather -> https://openweathermap.org/current
    const currentWeatherFetch = fetch(`https://${WEATHER_API_URL}/weather?lat=${lat}&lon=${lon}&appid=${WEATHER_API_KEY}&units=metric`)
    //Its for forecast of the weather-> https://openweathermap.org/forecast5
    const forecastWeatherFetch = fetch(`https://${WEATHER_API_URL}/forecast?lat=${lat}&lon=${lon}&appid=${WEATHER_API_KEY}&units=metric`)





    //Using promise to fetch all the data from the arrays 
    // Promise. all() method takes an iterable of promises as an input, and returns a single 
    // Promise that resolves to an array of the results of the input promises. This returned promise 
    // will fulfill when all of the input's promises have fulfilled, or if the input iterable contains no promises
    Promise.all([currentWeatherFetch, forecastWeatherFetch])
      .then(async (response) => {
        const weatherResponse = await response[0].json();//await for resoonse of index [0] in the promise.all array declaration
        const forecastResponse = await response[1].json();//Then map that data into json format
        setCurrentWeather({ city: searchData.label, ...weatherResponse });//searchData is coming from handleOnSearchChange function
        setForecastWeather({ city: searchData.label, ...forecastResponse });
      })

      .catch((err) => console.log(err));
  }
  // console.log(currentWeather);
  // console.log(forecastWeather);
  return (
    <>
      <Header />
      <div className="container-1">
        <Search onSearchChange={handleOnSearchChange} />

        {/* Store the object of current weather update in varaible or object name data then use it as prop to 
spread data in the current-weather.js file */}

        {currentWeather && <CurrentWeather data={currentWeather} />}
        {forecastWeather && <Forecast data={forecastWeather} />}
      </div>
      <Footer />

    </>
  );
}

export default App;